import moment from "moment";
import { AppealAPI } from "../api";
import Helper from "../plugins/Helper/Helper";
import AppealLabels from "../json/appeal-data.json";
import { Contract } from "./Contract.class";
import { Math } from "core-js";
export class Appeal {
  constructor(props) {
    const dateFormat = 'DD/MM/YYYY HH:mm'
    function round(secIn, n = 3) {
      let sec = 0
      if (secIn) {
        sec = Number((Math.round(secIn * (10 ^ n)) / (10 ^ n) / 60).toFixed(n))
      }
      return sec
    }
    function diffSec(start, end) {
      let sec = 0
      let startDate = start && start.iso ? moment(start.iso) : start ? moment(start) : null
      let ensDate = end && end.iso ? moment(end.iso) : end ? moment(end) : null
      if (startDate && ensDate) {
        sec = ensDate.diff(startDate, 'seconds', true)
      }
      return sec
    }
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
    this.statusText = this.status ? AppealLabels.status[this.status].text : ''
    this.categoryText = this.category ? AppealLabels.category[this.category].text : ''
    this.subCategoryText = this.subCategory ? AppealLabels.subCategory[this.subCategory].text : ''
    this.createdByText = this.createdBy ? `${this.createdBy.firstName} ${this.createdBy.lastName}` : '-'
    this.createdAtText = this.createdAt ? `${moment(this.createdAt).format(dateFormat)}` : '-'
    this.statusApprovedByText = this.statusApprovedBy ? `${this.statusApprovedBy.firstName} ${this.statusApprovedBy.lastName}` : '-'
    this.statusApprovedAtText = this.statusApprovedAt ? `${moment(this.statusApprovedAt.iso).format(dateFormat)}` : '-'
    this.statusPendingByText = this.statusPendingBy ? `${this.statusPendingBy.firstName} ${this.statusPendingBy.lastName}` : '-'
    this.statusPendingAtText = this.statusPendingAt ? `${moment(this.statusPendingAt.iso).format(dateFormat)}` : '-'
    this.statusSuccessByText = this.statusSuccessBy ? `${this.statusSuccessBy.firstName} ${this.statusSuccessBy.lastName}` : '-'
    this.statusSuccessAtText = this.statusSuccessAt ? `${moment(this.statusSuccessAt.iso).format(dateFormat)}` : '-'
    this.statusCancelledByText = this.statusCancelledBy ? `${this.statusCancelledBy.firstName} ${this.statusCancelledBy.lastName}` : '-'
    this.statusCancelledAtText = this.statusCancelledAt ? `${moment(this.statusCancelledAt.iso).format(dateFormat)}` : '-'

    this.time = {}

    this.time.pendingSec = diffSec(this.createdAt, this.statusPendingAt)
    this.time.pendingSec = this.time.pendingSec < 0 ? 0 : this.time.pendingSec
    this.time.pending = round(this.time.pendingSec)
    this.time.pendingFormat = Helper.dhm(this.time.pendingSec)

    this.time.approveSec = diffSec(this.statusPendingAt, this.statusApprovedAt)
    this.time.approveSec = this.time.approveSec < 0 ? 0 : this.time.approveSec
    this.time.approve = round(this.time.approveSec)
    this.time.approveFormat = Helper.dhm(this.time.approveSec)

    this.time.successSec = diffSec(this.statusApprovedAt, this.statusSuccessAt)
    this.time.successSec = this.time.successSec < 0 ? 0 : this.time.successSec
    this.time.success = round(this.time.successSec)
    this.time.successFormat = Helper.dhm(this.time.successSec)

    this.time.cancelledSec = diffSec(this.createdAt, this.statusCancelledAt)
    this.time.cancelledSec = this.time.cancelledSec < 0 ? 0 : this.time.cancelledSec
    this.time.cancelled = round(this.time.cancelledSec)
    this.time.cancelledFormat = Helper.dhm(this.time.cancelledSec)

    this.time.doneSec = this.time.cancelledSec ? this.time.cancelledSec : this.time.successSec ? (this.time.pendingSec + this.time.approveSec + this.time.successSec) : 0
    this.time.doneSec = this.time.doneSec < 0 ? 0 : this.time.doneSec
    this.time.done = round(this.time.doneSec)
    this.time.doneFormat = Helper.dhm(this.time.doneSec)

    if (this.contracts && this.contracts.length) {
      this.contracts = this.contracts.map(contract => new Contract(contract));
      if (this.subCategory == 'renew_contract' && this.requestData) {
        if (this.requestData.oldContract) this.renewOldContract = this.contracts.find(c => c.objectId == this.requestData.oldContract)
        if (this.requestData.newContract) this.renewNewContract = this.contracts.find(c => c.objectId == this.requestData.newContract)
      }
    }
    this.startDateFormat = this.startDate ? moment(this.startDate.iso).format('DD MMM YYYY') : '-'
    this.endDateFormat = this.endDate ? moment(this.endDate.iso).format('DD MMM YYYY') : '-'
    this.renewEffectiveDateFormat = this.effectiveDate ? moment(this.effectiveDate.iso).format('DD MMM YYYY') : '-'
    if (this.category == 'suspend' && this.requestData) {
      if (this.requestData.issueDate && this.requestData.issueDate.iso) this.requestData.issueDate = moment(this.requestData.issueDate.iso).format("YYYY-MM-DD")
      if (this.requestData.startDate && this.requestData.startDate.iso) this.requestData.startDate = moment(this.requestData.startDate.iso).format("YYYY-MM-DD")
      if (this.requestData.endDate && this.requestData.endDate.iso) this.requestData.endDate = moment(this.requestData.endDate.iso).format("YYYY-MM-DD") 
    }
  }
  static async createAppeal(payload) {
    const { data } = await AppealAPI.createAppeal(payload);
    return new Appeal(data.result);
  }
  static async updateAppeal(payload) {
    const { data } = await AppealAPI.updateAppeal(payload);
    return new Appeal(data.result);
  }
  static async changeStatusAppeal(payload) {
    const { data } = await AppealAPI.changeStatusAppeal(payload);
    return new Appeal(data.result);
  }
  static async getAppeals(payload) {
    const { data } = await AppealAPI.getAppeals(payload);
    return data.result.map(item => new Appeal(item));
  }
  static async getAppeal(payload) {
    const { data } = await AppealAPI.getAppeal(payload);
    return new Appeal(data.result);
  }
  static async getAppealsByMarket(payload) {
    const { data } = await AppealAPI.getAppealsByMarket(payload);
    return data.result.map(item => new Appeal(item));
  }
  static async getAppealsByProject(projectId, limit, page, order) {
    const { data } = await AppealAPI.getAppealsByProject(
      projectId,
      limit,
      page,
      order
    );
    return data.result.map(item => new Appeal(item));
  }
  static async checkWaitingStatus(payload) {
    const { data } = await AppealAPI.checkWaitingStatus(payload);
    data.result = data && data.result ? new Appeal(data.result) : null;
    return data.result;
  }
  static async getAppealBetweenDateByMarket(formData) {
    let { data } = await AppealAPI.getAppealBetweenDateByMarket(formData)
    return data.result.map(item => item = new Appeal(item));
  }
}
